var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSenai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 205,
    height: 55.668,
    viewBox: "0 0 205 55.668",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_142",
    "data-name": "Ret\\xE2ngulo 142",
    width: 205,
    height: 55.668,
    fill: "#f1ca64"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_407",
    "data-name": "Grupo 407",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_345",
    "data-name": "Caminho 345",
    d: "M43.14,3.281l-1.572,9.125a1.53,1.53,0,0,1-1.5,1.4H39.93c-2.876-.2-10.978-.658-16.119-.954-2.528-.145-4.469.678-4.08,3.065.248,1.521.7,1.668,3.143,3.132L31.6,24.289c5.15,3.065,7.157,7.082,7.157,12.189,0,13.653-11.27,19.2-23.443,19.2S4.849,54.863,1.2,53.774c-.636-.2-1.2-.579-1.2-1.226v-.2l1.5-8.989a1.7,1.7,0,0,1,1.638-1.464h.134c2.943.306,10.534,1.089,14.347,1.089s4.878-1.039,5.217-4.29c.153-1.47-.7-1.907-2.809-3.269l-9.264-6.2A14.411,14.411,0,0,1,4.615,17.173C4.615,4.03,14.714.081,26.118.081s13.109.954,15.918,1.839c.568.2,1.07.51,1.07,1.158v.2Z",
    transform: "translate(0 -0.013)",
    fill: "#f1ca64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_346",
    "data-name": "Caminho 346",
    d: "M91.926,2.383l-1.5,8.921a1.823,1.823,0,0,1-1.706,1.464H74.235c-2.576,0-3.579.885-4.081,3.643l-.936,5.311H86.843a1.17,1.17,0,0,1,1.2,1.226v.2l-1.5,8.615A1.752,1.752,0,0,1,84.9,33.23H67.279s-1.2,7.082-1.2,7.525c0,1.668.87,2.179,2.943,2.179H83.5a1.169,1.169,0,0,1,1.2,1.226v.2L83.131,53.25a1.677,1.677,0,0,1-1.639,1.464,100.368,100.368,0,0,1-14.113.885c-6.955,0-16.052-3.065-16.052-12.632s4.314-26.625,4.314-26.625C58.149,1.6,66.745,0,76.877,0S88.214.511,90.856.885c.8.068,1.136.443,1.136,1.158V2.35Z",
    transform: "translate(-8.054 0)",
    fill: "#f1ca64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_347",
    "data-name": "Caminho 347",
    d: "M149.929,2.392l-8.594,50.05a3.428,3.428,0,0,1-3.144,2.689h-8.9a2.614,2.614,0,0,1-2.642-1.975l-10.6-24.446c-.2-.511-.434-.578-.635-.578s-.368.136-.435.647l-4.314,24.889a1.823,1.823,0,0,1-1.706,1.464H98.227a1.169,1.169,0,0,1-1.2-1.226v-.2l8.6-50.084a3.428,3.428,0,0,1,3.143-2.69h8.762c1.371,0,1.939.885,2.508,2.111l10.9,25.2c.2.51.3.647.5.647s.434-.068.5-.647l4.447-25.842A1.823,1.823,0,0,1,138.09.928h10.769A1.1,1.1,0,0,1,150,2.086v.306Z",
    transform: "translate(-15.224 -0.146)",
    fill: "#f1ca64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_348",
    "data-name": "Caminho 348",
    d: "M199.7,55.006H187.53a1.3,1.3,0,0,1-1.2-1.4l-.2-10.146H173.351L169.538,53.61a2.067,2.067,0,0,1-1.639,1.4H155.225a.9.9,0,0,1-1-.954c0-.578.067-.374.133-.578L171.712,8.8c2.809-7.219,8.46-8.682,15.283-8.682S198.967,1.586,199.268,8.8l1.873,44.67v.068a1.386,1.386,0,0,1-1.371,1.464M185.724,13.264c0-.647,0-1.022-.636-1.022s-.735.375-.936,1.022L177.4,31.786h8.594l-.3-18.522Z",
    transform: "translate(-24.199 -0.019)",
    fill: "#f1ca64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_349",
    "data-name": "Caminho 349",
    d: "M239.976,2.284a1.111,1.111,0,0,0-1.2-1.4H227a1.662,1.662,0,0,0-1.639,1.4l-2.241,12.972,15.952-7.592.937-5.346Z",
    transform: "translate(-35.01 -0.14)",
    fill: "#f1ca64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_350",
    "data-name": "Caminho 350",
    d: "M220.875,23.377l-5.652,32.617a1.177,1.177,0,0,0,1.137,1.464h11.772a1.6,1.6,0,0,0,1.7-1.464l6.956-40.244-15.952,7.593Z",
    transform: "translate(-33.767 -2.472)",
    fill: "#f1ca64"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSenai);
export default __webpack_public_path__ + "static/media/logoSenai.097e4daac81069a02ec44ddb0d8ab487.svg";
export { ForwardRef as ReactComponent };